import { Controller } from "@hotwired/stimulus"
import { configureRemoteSearch } from "../../shared/multi_select"

export default class extends Controller {
  static values = { url: String }

  connect() {
    const select = this.element.matches("select") ? this.element : this.element.querySelector("select")
    this.cleanupRemoteSearch = configureRemoteSearch(select, {
      url: this.urlValue,
      resultsKey: "users",
      valueField: "clerk_code",
      labelField: "chinese_name"
    })
  }

  disconnect() {
    this.cleanupRemoteSearch?.()
  }
}
